/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import './styles.scss';
import { Divider, Tag, Popover } from 'antd-v5';
import { RightOutlined, EditOutlined } from '@ant-design/icons';

const QuickViewCard = ({
  children = null,
  borderColor,
  title,
  titleDescription,
  titleSubtext,
  hasFooter,
  handleAction = () => { },
  actionText,
  actionStyles = {},
  footerEditText,
  handleEdit = () => { },
  hasViewMore = false,
  onViewMore = () => { },
  action = null,
  onClick = null,
  containerStyle = {},
  titleClassName = '',
  titleId = null,
  hasEdit = true,
  actionButton = null,
  dividerStyles = {},
  virtual = false,
}) => {
  return (
    <div
      className="quick-view-card"
      style={{
        borderLeftColor: borderColor,
        cursor: onClick ? 'pointer' : 'default',
        borderLeftWidth: borderColor ? 4 : 0,
      }}
      onClick={onClick || (() => { })}
    >
      <div className="flex-row justify-between w-100-P p-btm-8">
        <div className="flex-col-left" style={{ ...containerStyle }}>
          <div className="flex-row gap-8 items-center">
            {title && (
              <h2 id={titleId} className={`quick-view-card-title ${titleClassName}`}>
                {title}
              </h2>
            )}
            {virtual && (
              <Popover
                content={
                  <div style={{ maxWidth: 250 }}>
                    Meeting details are coordinated by your team. Please message the client your video link or call instructions.
                  </div>
                }
                title="Virtual Appointments"
              >
                <Tag color="#F2F3F6" className="fw-600 fs-10" style={{ cursor: 'pointer', color: '#818181' }}>
                  VIRTUAL
                </Tag>
              </Popover>
            )}
            {titleSubtext && (
              <span className="fs-13 p-top-5" style={{ color: '#00000066' }}>
                {titleSubtext}
              </span>
            )}
          </div>
          {children}
        </div>
        <div className="flex-col-right gap-16 justify-between">
          <span className="fs-12" style={{ color: '#00000066' }}>
            {titleDescription}
          </span>
          {hasViewMore && <RightOutlined className="fs-18 pointer" onClick={onViewMore} />}
          {action}
        </div>
      </div>
      {hasFooter && (
        <>
          <Divider orientation="center" style={{ margin: '8px 0', ...dividerStyles }} />
          <div className="flex-row items-center justify-between">
            {actionButton || (
              <div style={{ color: '#33AAFC', ...actionStyles }} className="fw-500 pointer" onClick={handleAction}>
                {actionText || 'MESSAGE'}
              </div>
            )}
            {hasEdit && (
              <div
                className="flex-row items-center gap-8 pointer"
                style={{ color: '#7F7F7F80', '&:hover': { color: '#3D3D3D' } }}
                onClick={handleEdit}
              >
                <EditOutlined />
                {footerEditText}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default QuickViewCard;
